const Form023AEN = {
    formTitle: {
        Secondary:
            "Enhanced Native-speaking English Teacher (NET) Scheme in Secondary Schools Personal Particulars of NETs Recruited Directly by School",
        Primary:
            "Native-speaking English Teacher (NET) Scheme in Primary Schools Personal Particulars of NETs Recruited Directly by School",
    },
    stepName: {
        importantNotes: "Important Notes",
        application: "Application Information",
        confirmation: "Confirmation",
    },
    label: {
        note: "NOTE: To be completed by both the school and the new NET recruited by the school directly in the {{year}} school year",
        formType: "Form Type",
        part1: "PART I (To be completed by the NET)",
        part2: "Part II Declaration [ To be completed by the school ]",
        firstName: "First Name",
        familyName: "Family Name",
        title: "Title",
        titleOp: {
            Mr: "Mr.",
            Miss: "Miss",
            Mrs: "Mrs.",
            Ms: "Ms.",
        },
        date: "Date",
        dateOfBirth: "Date of Birth",
        nationality: "Nationality",
        contractPeriod: "Contract Period",
        signYear: " signed with the school for the {{year}} school year",
        effectiveDate: "(i)  Effective Date of Contract Period",
        endDate: "(ii) End Date of Contract Period",
        statement:
            "I have read, understood and agreed to the above terms and conditions.",
        college: "Colleges, Universities, etc. (Attended / Attending)",
        qualifications: "Qualifications (e.g. BA/MEd)",
        dateOfAward: "Date of Award (dd/mm/yyyy)",
        major: "Major Subjects",
        dateFrom: "From (mm/yyyy)",
        dateTo: "To (mm/yyyy)",
        fullOrPart: "Full or Part-Time",
        fullOrPartOp: {
            fullTime: "Full-time",
            partTime: "Part-time",
        },
        campusOrDistance: "On Campus / Distance Learning",
        campusOrDistanceOp: {
            campus: "On Campus",
            distance: "Distance Learning",
        },
        qualifications2: "Qualifications (e.g. Dip Teach/BEd/PGDE)",
        fullName: "Full Name of Issuing Authority",
        weeks: "No. of Weeks of Teaching Practice",
        qualifications3: "Qualifications (e.g. Cert/Dip/Master TESL/TEFL)",
        totalCourse: "Total Course Contact Hours",
        teachingPractice: "Teaching Practice (Y/N)",
        yesOrNo: {
            yes: "Yes",
            no: "No",
        },
        nameOfInstitution: "Name of Institution",
        age: "Age/Levels Taught",
        subjectsTaught: "Subjects Taught",
        confirmText1: "I confirm that, in the appointment of",
        confirmText2: "(Name of the NET), ",
        confirmText3: "all the appointment and qualification requirements",
        confirmText4:
            " of NETs in secondary schools as set out in EDB Circular Memorandum No. {{num}} on “Enhanced NET Scheme in Secondary Schools - Appointment and Re-appointment of NETs in the {{year}} School Year” have been followed.",
        document: "The following documents have been checked as appropriate:",
        documentOP1: "Academic qualification(s)",
        documentOP2: "Teacher training qualification(s)",
        documentOP3:
            "Qualifications assessment result for non-local qualifications issued by the Hong Kong Council for Accreditation of Academic and Vocational Qualifications",
        documentOP4:
            "Certificate(s) of service (with at least 1 year’s post-graduate experience of teaching English at secondary level or above)",
        documentOP5: "Certificate of No Criminal Conviction",
        documentOP6: "Employment visa",
        signature: "Signature of Supervisor / Principal:",
        name: "Name of Supervisor / Principal",
        supervisorOrPrincipal: {
            supervisor: "Supervisor",
            principal: "Principal",
        },
        nameOfNet: "Name of the NET",
        nameOfSchool: "Name of School",
        district: "District",
        schoolType: "School Type",
        schoolTypeOp: {
            aided: "Aided",
            caput: "Caput",
            special: "Special",
        },
        schoolTypeOp2: {
            aided: "Aided",
            special: "Special",
        },
        contactPerson: "Name of Contact Person",
        telNo: "Tel. No.",
        districtOp: {
            "Central and Western": "Central and Western",
            "Wan Chai": "Wan Chai",
            Eastern: "Eastern",
            Southern: "Southern",
            "Yau Tsim Mong": "Yau Tsim Mong",
            "Sham Shui Po": "Sham Shui Po",
            "Kowloon City": "Kowloon City",
            "Wong Tai Sin": "Wong Tai Sin",
            "Kwun Tong": "Kwun Tong",
            "Tsuen Wan": "Tsuen Wan",
            "Tuen Mun": "Tuen Mun",
            "Yuen Long": "Yuen Long",
            North: "North",
            "Tai Po": "Tai Po",
            "Sai Kung": "Sai Kung",
            "Sha Tin": "Sha Tin",
            "Kwai Tsing": "Kwai Tsing",
            Islands: "Islands",
        },
        formSelection: "Application Form Selection",
        part2Check:
            "After submission of on-line application, schools should send in the Acknowledgement of Form Submission and supporting documents with checklist {{part2CheckText}}",
        schoolsChecklist: "Checklist for schools",
        SecondCertificate:
            "Teaching of English as a Second/Foreign Language (TESL/TEFL) Qualifications at the Certificate Level",
        TEFLCertificate: "Certificate awarded by TEFL/TESL courses that:",
        TEFLDiploma:
            "Teaching of English as a Second/Foreign Language (TESL/TEFL) Qualifications at the Diploma Level",
        secondCertificateContent1:
            "Cambridge Certificate in Teaching English to Speakers of Other Languages (CELTA)",
        secondCertificateContent2:
            "The Trinity Certificate in Teaching English to Speakers of Other Languages (CertTESOL)",
        secondCertificateContent3:
            "Postgraduate Certificate in Education majoring in TEFL/TESL",
        teflCertificateContent1:
            "include a minimum of <b><i>100 contact hours;</i></b>",
        teflCertificateContent2:
            "include a minimum of <b>6 hours of observed and assessed teaching practice, a pass in which is required;</b> and",
        teflCertificateContent3:
            "cover the majority of the topics as described on page 8 of EDBCM.",
        teflDiplomaContent1:
            "Cambridge Diploma in Teaching English to Speakers of Other Languages (DELTA)",
        teflDiplomaContent2:
            "Trinity College London Licentiate Diploma in Teaching English to Speakers of Other Languages (DipTESOL)",
        teflDiplomaContent3:
            "Postgraduate Certificate in Education majoring in TEFL/TESL",
        teflDiplomaContent4: "Diploma awarded by TEFL/TESL courses that:",
        teflDiplomaContent4label1: "include at least 250 contact hours; and",
        teflDiplomaContent4label2:
            "include at least 20 hours of practicum in the programme, in which a pass is required OR require candidates to have at least two years’ teaching experience as a pre-requisite for entering the programme.",
    },
    tabel: {
        title1: "Academic Attainment:",
        title2: "Teacher Training Qualifications:",
        title3: "Teaching English as a Second/Foreign Language (TESL/TEFL) Qualification(s):",
        title4: "Post-Qualification Experience in Teaching English/ESL/EFL",
        title4a:
            "(Please include ONLY continuous employment of more than 3 months)",
    },
    note: {
        note1: "Reference Materials:",
        note2: "EDB Circular Memorandum Nos. {{num}} (NET Scheme in Primary Schools) :",
        note3: "https://www.edb.gov.hk/attachment/en/sch-admin/admin/about-sch-staff/net-scheme/EDBCM362021.pdf.pdf",
        note4: "EDB Circular Memorandum Nos. {{num}} (Enhanced NET Scheme in Secondary Schools):",
        note5: "https://www.edb.gov.hk/attachment/en/sch-admin/admin/about-sch-staff/net-scheme/EDBCM372021.pdf.pdf",
    },
    errorMsg: {
        morethan:
            "Please include ONLY continuous employment of more than 3 months",
        E0001: "Please input a valid school name",
        E0002: "Please input a valid school code",
        E0003: "Please input a valid rank before regrading",
        E0004: "Please input a valid rank upon regrading",
        E0006: "Please enter a valid file ref. No.",
        E0007: "Please input a valid contact person",
        E0008: "Monthly Salary Upon Regrading should not be greater than Maximum Salary",
        englishName: "Please input a valid name of teacher in English",
        chineseName: "Please input a valid name of teacher in Chinese",
        numberOnly: "Please input a valid number with 8 digits",
        substantiveRank: "Please input a valid substantive rank",
        rankOfActingAppointment:
            "Please input a valid rank of acting appointment",
        refNum: "Please input a valid reference number",
        digits: "{{name}} must be {{len}} digits",
        characters: "{{name}} must be {{len}} characters",
        hkidEmpty: "The value in the brackets cannot be empty",
        Note001:
            "Note 1.All the necessary procedures for promoting a teacher or making acting appointment should be completed before the effective date, including the approval by the SMC/IMC.  Under normal circumstances, there should be no retrospective effect for the date of promotion and acting appoint.",
    },
};
export default Form023AEN;
